import React from 'react';
import TopRowTitle from '../TopRowTitle';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IntegerFormFieldRow } from '@rd-web-markets/shared/dist/util/form';
import Dropdown from '@rd-web-markets/shared/dist/util/Dropdown';
const YES_NO_OPTIONS = [{
  key: 'yes',
  value: 'true',
  text: 'yes'
}, {
  key: 'no',
  value: 'false',
  text: 'no'
}];
const EligibleExpenseRow = _ref => {
  let {
    rowData,
    translationKey,
    index,
    updateState,
    eligibleExpenses,
    disabled = false,
    isYesNoField = false,
    isVersion8 = false
  } = _ref;
  const {
    t
  } = useTranslation();
  const renderInput = field => {
    if (isYesNoField) {
      return /*#__PURE__*/React.createElement(Dropdown, {
        name: field[0],
        value: field[1],
        onChange: () => {},
        options: YES_NO_OPTIONS,
        dataTestId: "eligible-expense-field-".concat(field[0]),
        showNullOption: true,
        disabled: disabled,
        dropdownStyle: {
          width: '100px'
        }
      });
    }
    return /*#__PURE__*/React.createElement(IntegerFormFieldRow, {
      fieldName: field[0],
      value: field[1],
      onChange: e => updateState({
        target: {
          value: e.target.value
        }
      }, eligibleExpenses, field[0]),
      dataTestId: "eligible-expense-field-".concat(field[0]),
      style: {
        width: '100px'
      },
      disabled: disabled
    });
  };
  return /*#__PURE__*/React.createElement("div", null, rowData[0] === 'eligible_expenses_from_wages_own_employees_before_jul_2020' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('determination_of_the_assessment_basis_for_eligible_expenses_incurred_before_version_7')
  }), /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('eligible_expenditure_from_in_house_research_and_development_projects_wages'),
    showTopLine: false
  })), rowData[0] === 'declared_working_hours_sole_proprietor_before_jul_2020' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('eligible_expenses_from_in_house_research_and_development_projects_own_contributions_by_a_sole_proprietor_or_by_partners_of_a_co_entrepreneurship')
  }), rowData[0] === 'total_remuneration_contract_research_before_jul_2020' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('eligible_expenditure_from_contract_research')
  }), rowData[0] === 'subtotal_eligible_expenses_before_jul_2020' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('subtotal_of_eligible_expenses_incurred_before_version_7')
  }), rowData[0] === 'eligible_expenses_from_wages_own_employees_after_jun_2020' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('determination_of_the_assessment_basis_for_eligible_expenses_incurred_after_version_7')
  }), /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('eligible_expenditure_from_in_house_research_and_development_projects_wages'),
    showTopLine: false
  })), rowData[0] === 'declared_working_hours_sole_proprietor_after_jun_2020' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('eligible_expenses_from_in_house_research_and_development_projects_own_contributions_by_a_sole_proprietor_or_by_partners_of_a_co_entrepreneurship')
  }), rowData[0] === 'total_remuneration_contract_research_after_jun_2020' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('eligible_expenditure_from_contract_research')
  }), rowData[0] === 'subtotal_eligible_expenses_after_jun_2020' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('subtotal_of_eligible_expenses_incurred_after_version_7')
  }), rowData[0] === 'eligible_expenses_before_jul_2020_capped_at_2m' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('determination_of_the_eligible_assessment_basis_for_the_respective_financial_year')
  }), rowData[0] === 'requested_research_allowance' && !isVersion8 && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('determination_of_the_research_allowance_applied_for')
  }), rowData[0] === 'eligible_expenses_from_wages_own_employees_before_mar_2024' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('determination_of_the_assessment_basis_for_eligible_expenses_incurred_before_version_8')
  }), /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('eligible_expenditure_from_in_house_research_and_development_projects_wages'),
    showTopLine: false
  })), rowData[0] === 'declared_working_hours_sole_proprietor_before_mar_2024' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('eligible_expenses_from_in_house_research_and_development_projects_own_contributions_by_a_sole_proprietor_or_by_partners_of_a_co_entrepreneurship')
  }), rowData[0] === 'total_remuneration_contract_research_before_mar_2024' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('eligible_expenditure_from_contract_research')
  }), rowData[0] === 'subtotal_eligible_expenses_before_mar_2024' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('subtotal_of_eligible_expenses_incurred_before_version_8')
  }), rowData[0] === 'eligible_expenses_from_wages_own_employees_after_mar_2024' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('determination_of_the_assessment_basis_for_eligible_expenses_incurred_after_version_8')
  }), /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('eligible_expenditure_from_in_house_research_and_development_projects_wages'),
    showTopLine: false
  })), rowData[0] === 'declared_working_hours_sole_proprietor_after_mar_2024' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('eligible_expenses_from_in_house_research_and_development_projects_own_contributions_by_a_sole_proprietor_or_by_partners_of_a_co_entrepreneurship')
  }), rowData[0] === 'total_depreciable_assets_acquisition_production_cost_difference_after_mar_2024' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('eligible_expenses_from_in_house_research_and_development_projects_acquisition_and_production_costs_of_depreciable_movable_fixed_assets_version_8')
  }), rowData[0] === 'total_remuneration_contract_research_after_mar_2024' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('eligible_expenses_from_contract_research')
  }), rowData[0] === 'subtotal_eligible_expenses_after_mar_2024' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('subtotal_of_eligible_expenses_incurred_after_version_8')
  }), rowData[0] === 'eligible_expenses_before_mar_2024_capped_at_4m' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('determination_of_the_eligible_assessment_basis_for_the_respective_financial_year')
  }), rowData[0] === 'sme_criteria_met_increased_funding_rate_applied_after_mar_2024' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('determination_of_the_research_allowance_applied_for')
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 7
  }, /*#__PURE__*/React.createElement("p", null, t(translationKey))), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, renderInput(rowData))));
};
export default EligibleExpenseRow;